// .components/ProfileForm
import PropTypes from 'prop-types';
import FormField from '../FormField';
import CountrySelector from '../CountrySelector';
import LanguageSelectorr from '../LanguageSelector';

const ProfileForm = ({ formData, onChange, onCountryChange, onSubmit, loading }) => (
  <div className="stack stack-normal">

    <div className="cluster cluster-normal">
      <FormField
        label="First Name"
        name="first_name"
        value={formData.first_name}
        onChange={onChange}
      />
      <FormField
        label="Last Name"
        name="last_name"
        value={formData.last_name}
        onChange={onChange}
      />
    </div>

    <FormField
      label="Display Name"
      name="display_name"
      value={formData.display_name}
      onChange={onChange}
      helpText="This will be shown when commenting."
    />

    <FormField
      label="Date of Birth"
      name="date_of_birth"
      type="date"
      value={formData.date_of_birth}
      onChange={onChange}
    />

    <FormField
      label="Address Line 1"
      name="address1"
      value={formData.address1}
      onChange={onChange}
    />

    <FormField
      label="Address Line 2"
      name="address2"
      value={formData.address2}
      onChange={onChange}
    />

    <div className="cluster cluster-normal">
      <FormField
        label="City"
        name="city"
        value={formData.city}
        onChange={onChange}
      />
      <FormField
        label="Zip Code"
        name="zip_code"
        value={formData.zip_code}
        onChange={onChange}
      />
      <CountrySelector
        value={formData.country}
        onChange={onCountryChange}
      />
    </div>

    <FormField
      label="Mobile Phone"
      name="mobile_phone"
      type="tel"
      value={formData.mobile_phone}
      onChange={onChange}
      placeholder="+1234567890"
      helpText="Format: +[country code][number]"
    />

    <FormField
      label="Additional Information"
      name="additional_information"
      as="textarea"
      value={formData.additional_information}
      onChange={onChange}
    />

    <button
      className="btn btn-primary"
      onClick={onSubmit}
      disabled={loading}
    >
      {loading ? 'Updating...' : 'Update Profile'}
    </button>

  </div>
);

ProfileForm.propTypes = {
  formData: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ProfileForm;
